import { LitElement, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { t } from '../i18n';
import { backGlyph } from '../bidi-html';
import { back, go, setLeaveGuard } from '../router';
import { loadOneButton } from '../one-button';
import './capture-form';
import type { CaptureForm } from './capture-form';

/**
 * The record screen (`/record`, `/record#wanted`): bookmarks and the onboarding's last screen open it. Home opens the
 * same form in a panel over its town instead (capture-sheet.ts).
 */
@customElement('record-view')
export class RecordView extends LitElement {
  protected createRenderRoot() { return this; }

  private guard = () => this.querySelector<CaptureForm>('capture-form')?.atStake() ? t('record.leaveUnsaved') : null;

  /** With one capture button (ticket 44) these two URLs open the lantern's and the quill's panels over home. */
  connectedCallback() {
    super.connectedCallback();
    setLeaveGuard(this.guard);
    void loadOneButton().then((on) => {
      if (on && this.isConnected) go(location.hash === '#wanted' ? '/#type' : '/#listen', true, true);
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    setLeaveGuard(null);
  }

  render() {
    return html`
      <div class="screen">
        <div class="topbar">
          <button class="btn ghost icon" @click=${() => back('/')} aria-label=${t('common.back')}>${backGlyph()}</button>
          <h1>${t('record.title')}</h1>
        </div>
        <capture-form></capture-form>
      </div>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap { 'record-view': RecordView }
}
